import { createActions } from 'redux-actions'

/**
 * @see app/components/Modal
 */
export const { modal } = createActions({
  MODAL: {
    SHOW: (children, restProps) => ({ children, restProps }),
    HIDE: undefined,
  },
})
